import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";

import { styled } from "@mui/material/styles";
import { IconHeartHandshake, IconFlameFilled } from "@tabler/icons-react";
import { MaterialDesignContent, SnackbarProvider } from "notistack";

import posthog from "posthog-js";
import { PostHogErrorBoundary, PostHogProvider } from "@posthog/react";

// project imports
import App from "App";
import { store } from "store";
import "themes/style.scss";
import { THEME_CONFIG } from "./config/app";
import { orange, pink } from "@mui/material/colors";

posthog.init(process.env.REACT_APP_PUBLIC_POSTHOG_KEY, {
  api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
  defaults: "2026-01-30",
});

// ==============================|| REACT DOM RENDER  ||============================== //

const StyledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
  "&.notistack-MuiContent-kudos": {
    backgroundColor: pink[500],
  },
  "&.notistack-MuiContent-streak": {
    backgroundColor: orange.A700,
  },
}));

const container = document.getElementById("root");
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
  <PostHogProvider client={posthog}>
    <PostHogErrorBoundary>
      <Provider store={store}>
        <BrowserRouter basename={THEME_CONFIG.basename}>
          <SnackbarProvider
            maxSnack={4}
            iconVariant={{
              kudos: (
                <IconHeartHandshake
                  style={{ marginRight: 8, minHeight: 24, minWidth: 24 }}
                />
              ),
              streak: (
                <IconFlameFilled
                  style={{ marginRight: 8, minHeight: 24, minWidth: 24 }}
                />
              ),
            }}
            Components={{
              kudos: StyledMaterialDesignContent,
              streak: StyledMaterialDesignContent,
            }}
          >
            <App />
          </SnackbarProvider>
        </BrowserRouter>
      </Provider>
    </PostHogErrorBoundary>
  </PostHogProvider>
);
